import { useState, useEffect, useRef } from 'react';

// Returns: undefined (loading) | null (no data / error) | array of items
export function useSectionData(fetcher) {
  const [items, setItems] = useState(undefined);
  const ref = useRef(fetcher);
  ref.current = fetcher;

  useEffect(() => {
    let active = true;
    ref.current().then(res => {
      if (!active) return;
      const data = res?.data;
      if (Array.isArray(data) && data.length > 0) {
        setItems(data);
      } else {
        setItems(null);
      }
    }).catch(() => {
      if (active) setItems(null);
    });
    return () => { active = false; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return items;
}

// For Strapi single types (about)
// Returns: undefined (loading) | null (error) | attributes object
export function useSingleData(fetcher) {
  const [data, setData] = useState(undefined);
  const ref = useRef(fetcher);
  ref.current = fetcher;

  useEffect(() => {
    let active = true;
    ref.current().then(res => {
      if (!active) return;
      setData(res?.data?.attributes ?? null);
    }).catch(() => {
      if (active) setData(null);
    });
    return () => { active = false; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return data;
}
